export { messages as defaultMessages } from './en/catalog'

export const localesCodes = [
  'en',
  'en-gb',
  'es',
  'es-419',
  'es-us',
  'fr',
  'id',
  'hi',
  'it',
  'ko',
  'pt-br',
  'uk',
  'tr',
  'vi',
  'zh',
  'zh-tw',
]

export const sourceLocale = 'en'

export const localeFiles = {
  en: () => import('./en/catalog.js'),
  'en-gb': () => import('./en-gb/catalog.js'),
  es: () => import('./es/catalog.js'),
  'es-419': () => import('./es-419/catalog.js'),
  'es-us': () => import('./es-us/catalog.js'),
  fr: () => import('./fr/catalog.js'),
  id: () => import('./id/catalog.js'),
  hi: () => import('./hi/catalog.js'),
  it: () => import('./it/catalog.js'),
  ko: () => import('./ko/catalog.js'),
  'pt-br': () => import('./pt-br/catalog.js'),
  uk: () => import('./uk/catalog.js'),
  tr: () => import('./tr/catalog.js'),
  vi: () => import('./vi/catalog.js'),
  zh: () => import('./zh/catalog.js'),
  'zh-tw': () => import('./zh-tw/catalog.js'),
}

// for supported country list in language selector
export const countryCodes = [
  'US',
  'AR',
  'IN',
  'CN',
  'UA',
  'KR',
  'VN',
  'UM',
  'GB',
  'ES',
  'FR',
  'ID',
  'IT',
  'BR',
  'TR',
  'TW',
]

export const countryCodeToLocale = {
  'US': 'en',
  'AR': 'es-419',
  'IN': 'hi',
  'CN': 'zh',
  'UA': 'uk',
  'KR': 'ko',
  'VN': 'vi',
  'UM': 'es-us',
  'GB': 'en-gb',
  'ES': 'es',
  'FR': 'fr',
  'ID': 'id',
  'IT': 'it',
  'BR': 'pt-br',
  'TR': 'tr',
  'TW': 'zh-tw',
}

export const languageLabels = {
  'US': 'English-United States',
  'AR': 'Español Latinoamericano',
  'IN': 'हिन्दी',
  'CN': '中文',
  'UA': 'Українська',
  'KR': '한국어',
  'VN': 'Tiếng Việt',
  'UM': 'Español-United States',
  'GB': 'English-United Kingdom',
  'ES': 'Spanish',
  'FR': 'French',
  'ID': 'Indonesian',
  'IT': 'Italian',
  'BR': 'Portuguese-Brazil',
  'TR': 'Turkish',
  'TW': 'Chinese (Traditional)-Taiwan',
}
